<template>
  <ExternalQueryList
      endpoint="/api/v2/invoices"
      :endpoint-filters="{recipient_id: recipientId, recipient_type: recipientType}"
      :headlines="headlines"
      :can-destroy="() => false"
      :can-update="() => true"
      @show="invoice => $router.push(getUrl(invoice))"
  >
    <template v-slot:default="{ row: invoice }">
      <td>
        {{ invoice.id }}
      </td>

      <td>
        {{ invoice.attributes.headline }}
      </td>

      <td>
        {{ invoice.attributes.created_at | date }}
      </td>

      <td>
        {{ invoice.attributes.price | price }}
      </td>

      <td>
        <StatusLabel :status="invoice.attributes.status"></StatusLabel>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import StatusLabel from "../../../StatusLabel.vue";

export default {
  components: {StatusLabel, ExternalQueryList},

  props: {
    recipientId: {
      required: true,
      type: [String, Number]
    },

    recipientType: {
      required: true,
      type: String
    }
  },

  computed: {
    headlines() {
      return [
        {width: 2, text: 'ID'},
        {width: 6, text: 'Headline'},
        {width: 6, text: 'Date'},
        {width: 4, text: 'Price'},
        {width: 4, text: 'Status'},
      ]
    },
  },

  methods: {
    getUrl(invoice) {
      return 'invoices/' + invoice.id
    }
  }
}
</script>
